export enum LiveDataReportType {
  ALCOHOL_LOCK = 'ALCOHOL_LOCK',
  PANIC_BUTTON = 'PANIC_BUTTON',
  ROUTE_CONTROL = 'ROUTE_CONTROL',
  OFF_COURSE = 'OFF_COURSE'
}
